import { CountryUS } from '@interfaces/models/us-country';
import { Action, createReducer, on } from '@ngrx/store';
import { YesNoEmpty } from '@shared/models';

import * as estateActions from '../../actions/estate/estate.actions';

export interface EstateState {
  tin_private?: string;
  estateName?: string;
  countryQuestion?: CountryUS;
  taxResidencyQuestion?: CountryUS;
  withholdingQuestion?: YesNoEmpty;
  signature?: string;
  date?: string;
}

export const initialState: EstateState = {
  tin_private: '',
};

const estateReducer = createReducer(
  initialState,
  on(estateActions.EstateUpdate, (_state, { payload }) => ({
    ...payload,
  })),
);

export function reducer(state: EstateState | undefined, action: Action) {
  return estateReducer(state, action);
}
